import React from 'react';
import Button from '@atlaskit/button/new';
import MagicWandIcon from '@atlaskit/icon/core/magic-wand';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const AiSuggestButton = ({ onClick }: { onClick: () => void }) => {
	const { formatMessage } = useIntl();
	return (
		<Button appearance="default" spacing="compact" onClick={onClick} iconBefore={MagicWandIcon}>
			{formatMessage(messages.buttonLabelSuggestWorkItems)}
		</Button>
	);
};
